import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Icon, Container, Image, Menu, Search, Button, Popup } from "semantic-ui-react"

import { range, reduce, filter, escapeRegExp, isEmpty, isEqual } from "lodash"
// import JWT from "jwt-client";

import { rand } from '../utils/rand'

import ExpiredTokenModal from './Modals/ExpiredTokenModal'
import ServerConfigModal from './Modals/ServerConfigModal'
import ChangelogModal from "./Modals/ChangelogModal"
import GlipNotificationsModal from './Modals/GlipNotificationsModal'

import fire from './App/fire';
import visp from "../assets/vispnetLogo.svg"

import { setOverviewData } from '../routes/Overview/overviewSlice'
import { setReferenceData } from '../routes/Reference/referenceSlice'
import { setChangelogData } from '../routes/Changelog/changelogSlice'
import { setChangelogModal } from './Modals/modalsSlice'
import { setActiveAction } from './App/appSlice'

const Header = (props) => {
  const history = useHistory()
  const { queries, mutations, types } = props
  const dispatch = useDispatch()
  const [showModal] = useState(false)
  const [showServerConfig, setShowServerConfig] = useState(false)
  const [showGlipConfig, setShowGlipConfig] = useState(false)
  const [results, setResults] = useState(null)
  const [value, setValue] = useState(null)
  const [isLoading, setIsLoading] = useState(null)
  const currentPage = window.location.pathname.split('/')[1]
  const activeAction = useSelector(state => state.app.activeAction)
  let changelog = useSelector(state => state.changelog.data)
  let overview = useSelector(state => state.overview)
  let reference = useSelector(state => state.reference)
  const open = useSelector(state => state.modals.changelogModal.open)
  // const validToken = JWT.validate(localStorage.getItem("Visp.token"));

  const contentActions = [
    { key: 'add', text: 'Add Content', icon: 'add' },
    { key: 'edit', text: 'Edit Content', icon: 'pencil' },
    { key: 'delete', text: 'Delete Content', icon: 'trash' },
  ]

  let options = [
    { key: 'addChangelog', text: 'Add Changelog', icon: 'add' },
    { key: 'glipNotif', text: 'Glip Notifications', icon: 'bullhorn' },
    { key: 'serverConfig', text: 'Server Config', icon: 'setting' },
    { key: 'signOut', text: 'Sign Out', icon: 'sign out' }
  ]

  // if (currentPage !== 'changelog') {
  //   options = options.filter(option => option.key !== 'addChangelog')
  // }

  if (currentPage !== 'explorer' && currentPage !== 'changelog') {
    options = [...contentActions, ...options]
  }

  // Getting data from firebase
  fire
    .database()
    .ref('reference')
    .orderByKey()
    .on('value', snapshot => {
      const updatedReference = snapshot.val()
      if (isEmpty(reference) && !isEqual(reference, updatedReference.fields)) {
        dispatch(setReferenceData(updatedReference.fields))
      }
    });

  fire
    .database()
    .ref('overview')
    .orderByKey()
    .on('value', snapshot => {
      const updatedOverview = snapshot.val()
      if (isEmpty(overview) && !isEqual(overview, updatedOverview.fields)) {
        dispatch(setOverviewData(updatedOverview.fields))
      }
    });

  fire
    .database()
    .ref('changelog')
    .orderByKey()
    .on('value', snapshot => {
      const updatedChangelogData = snapshot.val()
      if (isEmpty(changelog) && !isEqual(changelog, updatedChangelogData)) {
        dispatch(setChangelogData(updatedChangelogData))
      }
    });


  const handleResultSelect = (e, { result, results }) => {
    setValue(result.title)
    const selectedResult = new RegExp(`${"\\b"}${escapeRegExp(result.title)}`)

    const staticTitle = () => {
      if (overview && reference) {
        const overviewData = overview.data.map(val => { return val.header })
        const referenceData = reference.data.map(val => { return val.header })
        overviewData.find((value, index) => {
          if (result.title === value) {
            setTimeout(() => (window.location = `${'overview#'}${index}`), 10)
          }
          return 0
        })
        referenceData.find((value, index) => {
          if (result.title === value) {
            setTimeout(() => (window.location = `${'reference#'}${index}`), 10)
          }
          return 0
        })
      }
    }

    if (selectedResult.test(JSON.stringify(results.mutations))) {
      history.push(`${'/reference'}/${'mutations'}/${result.title}`)
    } else if (selectedResult.test(JSON.stringify(results.overview))) {
      history.push(`${'/overview'}`)
      staticTitle()
    } else if (selectedResult.test(JSON.stringify(results.queries))) {
      history.push(`${'/reference'}/${'queries'}/${result.title}`)
    } else if (selectedResult.test(JSON.stringify(results.reference))) {
      history.push(`${'/reference'}`)
      staticTitle()
    } else if (selectedResult.test(JSON.stringify(results.types))) {
      window.location = `${"/reference"}/${"types"}/${result.title}`
    }
  }

  const getResults = data => {
    let category
    if (data && types && overview && reference && mutations && queries) {
      switch (data) {
        case 'mutations':
          category = mutations.map((val) => { return val.name })
          break
        case 'queries':
          category = queries.map((val) => { return val.name })
          break
        case 'types':
          category = types.map((val) => { return val.name })
          break
        case 'overview':
          category = overview.data.map((val) => { return val.header })
          break
        case 'reference':
          category = reference.data.map((val) => { return val.header })
          break
        default:
          break
      }
      const results = category.map(value => {
        const newObject = {
          title: value
        }
        return newObject
      })
      return results
    }
  }

  const resetComponent = () => {
    setIsLoading(false)
    setValue('')
    setResults([])
  }

  const handleSearchChange = (e, { value }) => {
    const source = range(0, 3).reduce(memo => {
      const name = ["types", "queries", "mutations", "overview", "reference"]
      name.sort()
      for (let i = 0; i < name.length; i++) {
        memo[name[i]] = {
          name: name[i],
          results: getResults(name[i])
        }
      }
      return memo
    }, {})
    setIsLoading(true)
    setValue(value)
    setTimeout(() => {
      if (value.length < 1) return resetComponent()
      const re = new RegExp(escapeRegExp(value), "i")
      const isMatch = result => re.test(result.title)
      const filteredResults = reduce(
        source,
        (memo, data, name) => {
          const results = filter(data.results, isMatch)
          if (results.length) {
            const result = results.slice(0, 5)
            memo[name] = { name, results: result }
          }
          return memo
        },
        {}
      )
      setIsLoading(false)
      setResults(filteredResults)
    }, 500)
  }

  const handleLogout = () => {
    localStorage.removeItem("Visp.token")
    localStorage.removeItem("Visp.logged-in-as")
    window.location.reload()
  }

  const handleAction = (option) => {
    switch (option.key) {
      case 'signOut':
        handleLogout()
        break;
      case 'serverConfig':
        setShowServerConfig(true)
        break;
      case 'glipNotif':
        setShowGlipConfig(true)
        break;
      case 'addChangelog':
        dispatch(setChangelogModal({ open: true, action: 'add' }))
        break;
      default:
        dispatch(setActiveAction(activeAction !== option.key ? option.key : null))
        break;
    }
  }

  const handleCloseServerConfig = () => {
    setShowServerConfig(false)
  }

  const handleCloseGlipConfig = () => {
    setShowGlipConfig(false)
  }

  return (
    <Menu
      compact
      fluid
      inverted
      borderless
      stackable
      secondary
      attached="top"
      size="massive"
      style={{ height: "75px", backgroundColor: "#30457c" }}
    >
      <Container>
        <Menu.Item as={Link} to="/" position="left">
          <Icon as={Image} src={visp} width={40} height={40} />
          VISP GraphQL API Documentation
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item as="a" href="https://app.visp.net" target="_blank">
            App
          </Menu.Item>
          <Menu.Item as="a" href="https://visp.net/nuuz" target="_blank">
            Blog
          </Menu.Item>
          <Menu.Item>
            <Search
              category
              loading={isLoading}
              onResultSelect={handleResultSelect}
              onSearchChange={handleSearchChange}
              results={results}
              value={value}
              size="mini"
            />
            {/* localStorage.getItem("Visp.token") && localStorage.getItem("Visp.logged-in-as") !== 'docuadmin' &&
              <p style={{ marginLeft: "10px" }}>
                <Button content="Logout" color='orange' size='small' onClick={handleLogout} />
              </p> */
            }
            {localStorage.getItem('Visp.logged-in-as') === rand(true) &&
              (
                <p style={{ marginLeft: "10px" }}>
                  <Popup
                    on='click'
                    position='bottom right'
                    trigger={<Button icon='user' color='linkedin' size='small' circular content='Actions' />}
                    size='mini'
                  >
                    <Menu
                      vertical
                      compact
                      secondary
                    >
                      {options.map(option => (
                        <Menu.Item
                          active={option.key === activeAction}
                          key={option.key}
                          onClick={() => handleAction(option)}
                        >
                          {option.text}
                          <Icon
                            name={option.icon}
                            color={activeAction !== option.key ?
                              'black' : activeAction === 'delete' ? 'red' : 'blue'
                            } />
                        </Menu.Item>
                      ))}
                    </Menu>
                  </Popup>
                </p>
              )
            }
          </Menu.Item>
        </Menu.Menu>
        <ExpiredTokenModal showModal={showModal} handleLogout={handleLogout} />
        <ServerConfigModal open={showServerConfig} onCloseServerConfig={handleCloseServerConfig} />
        <GlipNotificationsModal open={showGlipConfig} onCloseGlipConfig={handleCloseGlipConfig} />
        {open && <ChangelogModal />}
      </Container>
    </Menu>
  )
}

export default Header
